import React, { useRef, useEffect, useCallback } from 'react';

const STAR_COUNT = 80;
const ALIEN_ROWS = 3;
const ALIEN_COLS = 8;
const ALIEN_SIZE = 20;
const SHIP_W = 48;
const SHIP_H = 38;
const BULLET_SPEED = 4.5;
const ALIEN_DROP_SPEED = 0.3;
const SHOOT_INTERVAL = 18;
const CODE_BULLETS = ['</', '/>', '{ }', 'go', 'fn', '( )', '0x', '++', '=>', '&&'];

function drawPixelShip(ctx, x, y, w, h, color, frame) {
  const s = w / 9;

  // Engine glow (animated)
  const glowSize = 3 + Math.sin(frame * 0.2) * 1.5;
  ctx.fillStyle = 'rgba(251, 191, 36, 0.12)';
  ctx.beginPath();
  ctx.arc(x + w / 2, y + h + 4, w * 0.35, 0, Math.PI * 2);
  ctx.fill();

  // Thruster flames (flickering)
  ctx.fillStyle = `rgba(251, 191, 36, ${0.5 + Math.random() * 0.3})`;
  ctx.fillRect(x + s * 3, y + h, s * 1.2, glowSize + Math.random() * 4);
  ctx.fillRect(x + s * 5, y + h, s * 1.2, glowSize + Math.random() * 4);
  ctx.fillStyle = `rgba(239, 68, 68, ${0.3 + Math.random() * 0.2})`;
  ctx.fillRect(x + s * 3.2, y + h + 3, s * 0.8, glowSize + Math.random() * 3);
  ctx.fillRect(x + s * 5.2, y + h + 3, s * 0.8, glowSize + Math.random() * 3);

  // Wings (outer)
  ctx.fillStyle = '#166534';
  ctx.fillRect(x, y + h * 0.55, s * 2.5, h * 0.35);
  ctx.fillRect(x + s * 6.5, y + h * 0.55, s * 2.5, h * 0.35);

  // Wing tips
  ctx.fillStyle = '#15803d';
  ctx.fillRect(x - s * 0.3, y + h * 0.6, s * 1, h * 0.25);
  ctx.fillRect(x + s * 8.3, y + h * 0.6, s * 1, h * 0.25);

  // Main body
  ctx.fillStyle = color;
  ctx.fillRect(x + s * 2.5, y + s, s * 4, h - s);

  // Nose
  ctx.fillStyle = '#4ade80';
  ctx.fillRect(x + s * 3.5, y, s * 2, s * 1.5);
  ctx.fillRect(x + s * 4, y - s * 0.5, s * 1, s);

  // Cockpit (windshield)
  ctx.fillStyle = '#06b6d4';
  ctx.fillRect(x + s * 3.8, y + s * 1.2, s * 1.4, s * 1.8);
  // Cockpit shine
  ctx.fillStyle = 'rgba(255,255,255,0.25)';
  ctx.fillRect(x + s * 3.9, y + s * 1.3, s * 0.5, s * 0.8);

  // Wing details (stripes)
  ctx.fillStyle = '#fbbf24';
  ctx.fillRect(x + s * 0.5, y + h * 0.62, s * 1.5, s * 0.3);
  ctx.fillRect(x + s * 7, y + h * 0.62, s * 1.5, s * 0.3);

  // Gun barrels
  ctx.fillStyle = '#a1a1aa';
  ctx.fillRect(x + s * 2.8, y + s * 0.5, s * 0.5, s * 2);
  ctx.fillRect(x + s * 5.7, y + s * 0.5, s * 0.5, s * 2);
}

function drawAlien(ctx, x, y, size, type, frame) {
  const s = size / 6;
  const colors = ['#ef4444', '#f97316', '#a855f7', '#ec4899', '#eab308'];
  ctx.fillStyle = colors[type % colors.length];

  if (type % 3 === 0) {
    ctx.fillRect(x + s * 2, y, s * 2, s);
    ctx.fillRect(x + s, y + s, s * 4, s);
    ctx.fillRect(x, y + s * 2, s * 6, s * 2);
    ctx.fillRect(x + s, y + s * 4, s, s);
    ctx.fillRect(x + s * 4, y + s * 4, s, s);
    ctx.fillStyle = '#050508';
    ctx.fillRect(x + s * 1.5, y + s * 2.5, s * 0.8, s * 0.8);
    ctx.fillRect(x + s * 3.5, y + s * 2.5, s * 0.8, s * 0.8);
    if (frame % 40 < 20) {
      ctx.fillStyle = colors[type % colors.length];
      ctx.fillRect(x + s, y - s * 0.5, s * 0.5, s);
      ctx.fillRect(x + s * 4.5, y - s * 0.5, s * 0.5, s);
    }
  } else if (type % 3 === 1) {
    ctx.fillRect(x + s, y, s * 4, s * 2);
    ctx.fillRect(x, y + s, s * 6, s * 2);
    ctx.fillRect(x + s, y + s * 3, s * 4, s);
    ctx.fillRect(x, y + s * 4, s * 1.5, s);
    ctx.fillRect(x + s * 4.5, y + s * 4, s * 1.5, s);
    ctx.fillStyle = '#050508';
    ctx.fillRect(x + s * 1.5, y + s * 1.2, s, s * 0.8);
    ctx.fillRect(x + s * 3.5, y + s * 1.2, s, s * 0.8);
  } else {
    ctx.fillRect(x + s * 2, y, s * 2, s);
    ctx.fillRect(x + s, y + s, s * 4, s);
    ctx.fillRect(x, y + s * 2, s * 6, s * 1.5);
    ctx.fillRect(x + s, y + s * 3.5, s * 4, s);
    ctx.fillStyle = '#06b6d4';
    ctx.fillRect(x + s * 2.5, y + s * 0.3, s, s * 0.5);
    ctx.fillStyle = frame % 30 < 15 ? '#fbbf24' : '#22c55e';
    ctx.fillRect(x + s * 0.5, y + s * 2.3, s * 0.5, s * 0.5);
    ctx.fillRect(x + s * 5, y + s * 2.3, s * 0.5, s * 0.5);
  }
}

export default function SpaceShooter() {
  const canvasRef = useRef(null);
  const stateRef = useRef(null);
  const animRef = useRef(null);
  const frameRef = useRef(0);
  const mouseRef = useRef({ x: -1, active: false });

  const initGame = useCallback((w, h) => {
    const stars = [];
    for (let i = 0; i < STAR_COUNT; i++) {
      stars.push({
        x: Math.random() * w,
        y: Math.random() * h,
        size: Math.random() * 1.5 + 0.5,
        speed: Math.random() * 0.4 + 0.1,
        brightness: Math.random() * 0.5 + 0.3,
      });
    }

    const aliens = [];
    const startX = w * 0.12;
    const gap = (w * 0.76) / ALIEN_COLS;
    for (let r = 0; r < ALIEN_ROWS; r++) {
      for (let c = 0; c < ALIEN_COLS; c++) {
        aliens.push({
          x: startX + c * gap,
          y: 40 + r * (ALIEN_SIZE + 20),
          type: r,
          alive: true,
          baseX: startX + c * gap,
          driftOffset: Math.random() * Math.PI * 2,
        });
      }
    }

    return {
      w, h, stars, aliens,
      ship: { x: w / 2 - SHIP_W / 2 },
      bullets: [],
      particles: [],
      score: 0,
      shootTimer: 0,
      respawnTimer: 0,
    };
  }, []);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let running = true;

    const resize = () => {
      const parent = canvas.parentElement;
      if (!parent) return;
      const rect = parent.getBoundingClientRect();
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = rect.width * dpr;
      canvas.height = rect.height * dpr;
      canvas.style.width = rect.width + 'px';
      canvas.style.height = rect.height + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      const prevScore = stateRef.current ? stateRef.current.score : 0;
      stateRef.current = initGame(rect.width, rect.height);
      stateRef.current.score = prevScore;
    };

    resize();
    window.addEventListener('resize', resize);

    // Mouse tracking on the entire hero section (parent)
    const heroSection = canvas.parentElement;

    const onMouseMove = (e) => {
      const rect = canvas.getBoundingClientRect();
      mouseRef.current = { x: e.clientX - rect.left, active: true };
    };
    const onMouseLeave = () => {
      mouseRef.current = { ...mouseRef.current, active: false };
    };
    const onTouchMove = (e) => {
      const rect = canvas.getBoundingClientRect();
      const touch = e.touches[0];
      if (touch) {
        mouseRef.current = { x: touch.clientX - rect.left, active: true };
      }
    };

    if (heroSection) {
      heroSection.addEventListener('mousemove', onMouseMove);
      heroSection.addEventListener('mouseleave', onMouseLeave);
      heroSection.addEventListener('touchmove', onTouchMove, { passive: true });
      heroSection.addEventListener('touchend', onMouseLeave);
    }

    const loop = () => {
      if (!running || !stateRef.current) return;
      const st = stateRef.current;
      const { w, h } = st;
      frameRef.current++;
      const frame = frameRef.current;

      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, w, h);

      // Draw stars
      for (const star of st.stars) {
        star.y += star.speed;
        if (star.y > h) { star.y = 0; star.x = Math.random() * w; }
        const twinkle = star.brightness + Math.sin(frame * 0.03 + star.x) * 0.15;
        ctx.fillStyle = `rgba(255,255,255,${twinkle})`;
        ctx.fillRect(Math.round(star.x), Math.round(star.y), star.size, star.size);
      }

      // Ship movement — follow mouse if active, else auto-target
      const shipY = h - 75;

      if (mouseRef.current.active && mouseRef.current.x > 0) {
        // Mouse control: ship follows mouse X
        const targetX = mouseRef.current.x - SHIP_W / 2;
        st.ship.x += (targetX - st.ship.x) * 0.12;
      } else {
        // Auto-pilot: target nearest alien
        const aliveAliens = st.aliens.filter(a => a.alive);
        let targetAlien = null;
        let minDist = Infinity;
        for (const a of aliveAliens) {
          const d = Math.abs(a.x - (st.ship.x + SHIP_W / 2));
          if (d < minDist) { minDist = d; targetAlien = a; }
        }
        const autoTarget = targetAlien
          ? targetAlien.x + ALIEN_SIZE / 2 - SHIP_W / 2
          : w / 2 - SHIP_W / 2;
        st.ship.x += (autoTarget - st.ship.x) * 0.025;
      }

      st.ship.x = Math.max(5, Math.min(w - SHIP_W - 5, st.ship.x));

      const aliveAliens = st.aliens.filter(a => a.alive);

      // Auto-shoot (fires from both gun barrels)
      st.shootTimer++;
      if (st.shootTimer >= SHOOT_INTERVAL && aliveAliens.length > 0) {
        st.shootTimer = 0;
        const label = CODE_BULLETS[Math.floor(Math.random() * CODE_BULLETS.length)];
        // Left barrel
        st.bullets.push({
          x: st.ship.x + SHIP_W * 0.33,
          y: shipY - 2,
          label,
        });
        // Right barrel
        st.bullets.push({
          x: st.ship.x + SHIP_W * 0.67,
          y: shipY - 2,
          label: CODE_BULLETS[Math.floor(Math.random() * CODE_BULLETS.length)],
        });
      }

      // Update bullets
      for (let i = st.bullets.length - 1; i >= 0; i--) {
        const b = st.bullets[i];
        b.y -= BULLET_SPEED;
        if (b.y < -20) { st.bullets.splice(i, 1); continue; }

        // Check collision with aliens
        for (const a of st.aliens) {
          if (!a.alive) continue;
          if (b.x > a.x - 4 && b.x < a.x + ALIEN_SIZE + 4 && b.y > a.y - 4 && b.y < a.y + ALIEN_SIZE + 4) {
            a.alive = false;
            st.bullets.splice(i, 1);
            st.score += 10;
            // Bigger explosion
            for (let p = 0; p < 12; p++) {
              const angle = (Math.PI * 2 * p) / 12;
              const speed = 1.2 + Math.random() * 2;
              st.particles.push({
                x: a.x + ALIEN_SIZE / 2,
                y: a.y + ALIEN_SIZE / 2,
                vx: Math.cos(angle) * speed,
                vy: Math.sin(angle) * speed,
                life: 35 + Math.random() * 20,
                maxLife: 55,
                size: 2 + Math.random() * 3,
                color: ['#fbbf24', '#f97316', '#ef4444', '#22c55e'][Math.floor(Math.random() * 4)],
              });
            }
            break;
          }
        }
      }

      // Update aliens
      for (const a of st.aliens) {
        if (!a.alive) continue;
        a.y += ALIEN_DROP_SPEED;
        a.x = a.baseX + Math.sin(frame * 0.015 + a.driftOffset) * 22;
        if (a.y > h + 20) {
          a.y = -30 - Math.random() * 60;
          a.alive = true;
        }
      }

      // Respawn dead aliens
      st.respawnTimer++;
      if (st.respawnTimer > 180) {
        st.respawnTimer = 0;
        const dead = st.aliens.filter(a => !a.alive);
        if (dead.length > ALIEN_COLS) {
          for (let i = 0; i < Math.min(ALIEN_COLS, dead.length); i++) {
            dead[i].alive = true;
            dead[i].y = -30 - Math.random() * 80;
          }
        }
      }

      // Update particles
      for (let i = st.particles.length - 1; i >= 0; i--) {
        const p = st.particles[i];
        p.x += p.vx;
        p.y += p.vy;
        p.vx *= 0.96;
        p.vy *= 0.96;
        p.life--;
        if (p.life <= 0) { st.particles.splice(i, 1); }
      }

      // --- DRAW ---

      // Draw aliens
      for (const a of st.aliens) {
        if (!a.alive) continue;
        drawAlien(ctx, a.x, a.y, ALIEN_SIZE, a.type, frame);
      }

      // Draw bullets
      ctx.font = '700 10px "JetBrains Mono", monospace';
      ctx.textAlign = 'center';
      for (const b of st.bullets) {
        // Glow
        ctx.fillStyle = 'rgba(34, 197, 94, 0.18)';
        ctx.fillRect(b.x - 8, b.y - 5, 16, 14);
        // Trail
        ctx.fillStyle = 'rgba(34, 197, 94, 0.1)';
        ctx.fillRect(b.x - 1.5, b.y, 3, 20);
        // Text
        ctx.fillStyle = '#22c55e';
        ctx.fillText(b.label, b.x, b.y + 5);
      }

      // Draw particles
      for (const p of st.particles) {
        const alpha = p.life / p.maxLife;
        ctx.fillStyle = p.color;
        ctx.globalAlpha = alpha;
        ctx.fillRect(Math.round(p.x), Math.round(p.y), p.size, p.size);
      }
      ctx.globalAlpha = 1;

      // Draw player ship
      drawPixelShip(ctx, Math.round(st.ship.x), shipY, SHIP_W, SHIP_H, '#22c55e', frame);

      // Draw "TS" on ship body
      ctx.font = 'bold 10px "JetBrains Mono", monospace';
      ctx.textAlign = 'center';
      ctx.fillStyle = '#050508';
      ctx.fillText('TS', Math.round(st.ship.x) + SHIP_W / 2, shipY + SHIP_H * 0.6);

      // Score display (top-left, subtle)
      ctx.font = '600 11px "JetBrains Mono", monospace';
      ctx.textAlign = 'left';
      ctx.fillStyle = 'rgba(34, 197, 94, 0.35)';
      ctx.fillText(`SCORE: ${st.score}`, 16, h - 16);

      animRef.current = requestAnimationFrame(loop);
    };

    animRef.current = requestAnimationFrame(loop);

    return () => {
      running = false;
      if (animRef.current) cancelAnimationFrame(animRef.current);
      window.removeEventListener('resize', resize);
      if (heroSection) {
        heroSection.removeEventListener('mousemove', onMouseMove);
        heroSection.removeEventListener('mouseleave', onMouseLeave);
        heroSection.removeEventListener('touchmove', onTouchMove);
        heroSection.removeEventListener('touchend', onMouseLeave);
      }
    };
  }, [initGame]);

  return (
    <canvas
      ref={canvasRef}
      className="absolute inset-0 w-full h-full"
      style={{ zIndex: 0, pointerEvents: 'none' }}
    />
  );
}
